// extracted by mini-css-extract-plugin
module.exports = {"section":"HomeSecurity-module--section--3RSwB","container":"HomeSecurity-module--container--8J4mn","text":"HomeSecurity-module--text--3xRbc"};